<section class="authorization-details">
    <h3 class="section-heading">Authorization Details</h3>
    @if (isEmpty) {
        <p class="empty-state">Authorization details not available</p>
    } @else {
        <div class="section-grid">
            <div>
                <span class="field-label">Authorization Type</span>
                <p class="field-value">{{ details.authorizationType }}</p>
            </div>
            <div>
                <span class="field-label">Authorization Date &amp; Time</span>
                <p class="field-value">{{ details.authorizationDateTime | date:"MMMM d, yyyy 'at' h:mm a" }}</p>
            </div>
            <div>
                <span class="field-label">Authorization Reference</span>
                <p class="field-value">{{ details.authorizationReference ?? "—" }}</p>
            </div>
        </div>
    }
</section>
